import { useState, useEffect, useCallback } from 'react';
import useFetch from 'use-http';
import Toggle from './Elements/TunnelTypeToggle';
import Dropdown from "./Elements/TunnelConfigDropdown";
import config from "../../../config";
export default function TunnelConnect(props: any) {
  const { post, response } = useFetch(config.url);
  const [devices, setDevices] = useState([]);
  const [ikeVersion, setIkeVersion] = useState("IKEv2");
  const [device, setDevice] = useState({VpnConnectionDeviceTypeId: '', VpnConnectionDeviceTypeName: ''});
  const [showAdvancedTunnelConfig, setShowadvancedTunnelConfig] = useState(false);

  useEffect(() => { getDeviceList(); }, []);

  const getDeviceList = async() => {
    const body = { environment: props.selectedEnvironment };
    const devices: any = await post(`ipsec/devices/${props.user.attributes.id}`, body);
    if (response.ok && devices) {
      console.dir(devices);
      setDevices(devices);
    }
  }
  const toggleIkeVersion = () => {  
    setIkeVersion(props.tunnel.ikeVersion === "IKEV1" ? "IKEV2" : "IKEV1");
  }
  const selectHandler = (device: any) => {
    setDevice(device);
  };
  const downloadML7Config = async (tunnel: any) => {
    const body = {
      left: tunnel.SK.split('#')[1],
      leftSubnet: tunnel.Routes[0].DestinationCidrBlock,
      leftIp: tunnel.SK.split('#')[1],
      right: tunnel.tunnel1_ip,
      rightSubnet: tunnel.Options.RemoteIpv4NetworkCidr,
      rightSecondary: tunnel.tunnel2_ip,
      rightSubnetSecondary: tunnel.Options.RemoteIpv4NetworkCidr,
      psk: tunnel.tunnel1_psk,
      pskSecondary: tunnel.tunnel2_psk,
      selected: props.selectedEnvironment,
      leftSubnetSecondary: tunnel?.Routes[1]?.DestinationCidrBlock ? tunnel.Routes[1].DestinationCidrBlock : '',
    };
    const config: any = await post(`ipsec/generate-custom-config/${props.user.attributes.id}`, body);
    if (response.ok && config) {
      const element = document.createElement("a");
      const file = new Blob([config.customConfig], {type: 'text/plain'});
      element.href = URL.createObjectURL(file);
      element.download = "quick-connect.sh";
      document.body.appendChild(element);
      element.click();
    }
  }
  const downloadTunnelConfig = async (tunnel: any) => {
    const body = {
      VpnConnectionDeviceTypeId: device.VpnConnectionDeviceTypeId,
      VpnConnectionId: tunnel.vpnConnectionId,
      ikeVersion: ikeVersion,
      environment: props.selectedEnvironment,
    }
    const downloadRequest: any = await post(`ipsec/get-config/${props.user.attributes.id}`, body);
    console.dir(downloadRequest);
    if (downloadRequest?.configRequest.VpnConnectionDeviceSampleConfiguration) {
      const element = document.createElement("a");
      const file = new Blob([downloadRequest.configRequest.VpnConnectionDeviceSampleConfiguration], {type: 'text/plain'});
      element.href = URL.createObjectURL(file);
      element.download = "sample-config.txt";
      document.body.appendChild(element);
      element.click();   
    }
  } 
  return (
    <div className="divide-y divide-solid">
      <div className='py-2 text-center text-md font-medium text-gray-200'>
        Quick&nbsp;&nbsp;<Toggle enabled={showAdvancedTunnelConfig} name={showAdvancedTunnelConfig} setEnabled={ () => setShowadvancedTunnelConfig(!showAdvancedTunnelConfig) } />&nbsp;&nbsp;Advanced 
      </div>
    { showAdvancedTunnelConfig ?
      <div className="pb-5 pt-2 text-sm">
        <p className=' text-center text-lg font-medium'>Advanced Setup</p>
          <div className='pb-2'>IKEv1&nbsp;&nbsp;<Toggle enabled={ikeVersion} name={ikeVersion} setEnabled={ toggleIkeVersion }/>&nbsp;&nbsp;IKEv2</div>
        <Dropdown className="w-full" selectHandler={selectHandler} devices={devices}/>
        <button onClick={() => {downloadTunnelConfig(props.tunnel)}} className="mt-2 w-full bg-cyan-500 hover:bg-cyan-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button">
          Download
        </button>
        { props.tunnel.showDownloadTunnelConfig ?
          <button className="mt-2 w-full bg-gray-500 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" 
            type="button" 
            onClick={ () => { props.showDownloadTunnelConfigClickHandler(props.tunnel) }}
          >
            Done
          </button> : '' }
      </div> 
      : 
      <div className="pb-5 pt-2 text-gray-200">
        <p className=' text-center text-lg font-medium'>Quick Setup</p>
        <p className='text-sm pt-1'>Quick setup installs open source IPsec tools onto your kernel to
          facilitate a policy-based, subnet-to-subnet tunnel securing traffic from you to the Retrohook platform.</p>
        <p className='text-md pt-4 text-gray-300'>Step 1:&nbsp; 
        <span className='text-sm pt-1 text-cyan-400'>Download the install script below to setup 
        the connection to the Retrohook platform.</span>
        </p>
        <button onClick={() => {downloadML7Config(props.tunnel)}} 
          className="mt-2 w-full bg-gray-500 hover:bg-cyan-400 text-white font-bold py-2 px-4 
          rounded focus:outline-none focus:shadow-outline" type="button">
          Download Script
        </button>
          <p className='text-md pt-4 text-gray-300'>Step 2:&nbsp; 
        <span className='text-sm pt-1 text-cyan-400'>This script can be run from anywhere just cd into the directory where it is located.</span>
        </p> 
        <p className='text-md pt-4 text-gray-300'>Step 3:&nbsp; 
        <span className='text-sm pt-1 text-cyan-400'>Then execute the shell script using sudo ./quicksetup.sh</span>
        </p>
        { props.tunnel.showDownloadTunnelConfig ?
          <button className="mt-2 w-full bg-gray-500 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" 
            type="button" onClick={  () => {props.showDownloadTunnelConfigClickHandler(props.tunnel) }}>Done</button>
            : '' }
      </div>
        }
    </div>  
  );
}

